import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import InteractiveShortcutAPI from '../../api/interactiveShortcut';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getInteractiveShortcuts(_state) {
    return _state.records;
  },
  getSortedInteractiveShortcuts(_state) {
    return sortOrder =>
      [..._state.records].sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.short_code.localeCompare(b.short_code);
        }
        return b.short_code.localeCompare(a.short_code);
      });
  },
  getInteractiveShortcutUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getInteractiveShortcuts: async function getInteractiveShortcuts(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
      fetchingList: true,
    });
    try {
      const response = await InteractiveShortcutAPI.get({ searchKey });
      commit(types.default.SET_INTERACTIVE_SHORTCUTS, response.data);
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        fetchingList: false,
      });
    } catch (error) {
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createInteractiveShortcut: async function createInteractiveShortcut(
    { commit },
    shortcut
  ) {
    commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
      creatingItem: true,
    });
    try {
      const response = await InteractiveShortcutAPI.create(shortcut);
      commit(types.default.ADD_INTERACTIVE_SHORTCUT, response.data);
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        creatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        creatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  updateInteractiveShortcut: async function updateInteractiveShortcut(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await InteractiveShortcutAPI.update(id, updateObj);
      commit(types.default.EDIT_INTERACTIVE_SHORTCUT, response.data);
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        updatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        updatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  deleteInteractiveShortcut: async function deleteInteractiveShortcut(
    { commit },
    id
  ) {
    commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
      deletingItem: true,
    });
    try {
      await InteractiveShortcutAPI.delete(id);
      commit(types.default.DELETE_INTERACTIVE_SHORTCUT, id);
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        deletingItem: false,
      });
      return id;
    } catch (error) {
      commit(types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG, {
        deletingItem: false,
      });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_INTERACTIVE_SHORTCUT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_INTERACTIVE_SHORTCUTS]: MutationHelpers.set,
  [types.default.ADD_INTERACTIVE_SHORTCUT]: MutationHelpers.create,
  [types.default.EDIT_INTERACTIVE_SHORTCUT]: MutationHelpers.update,
  [types.default.DELETE_INTERACTIVE_SHORTCUT]: MutationHelpers.destroy,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
